import React, { useEffect, useState } from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import { commonRunQuery } from "../../../util/API/loans";
import { setAsArray } from "../../../util/utilfunctions/utilFunctions";
import UserOFACTable from "../../UserOFACTable/UserOFACTable";

function OFACHistory({
  selectedUser,
  selectedUserData,
  setSelectedUserData,
}) {
  const [oFACHistory, setOFACHistory] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  let isAdmin = sessionStorage.getItem("isAdmin");


  useEffect(() => {
      getOFACHistoryData();
  }, []);

  const getOFACHistoryData = async() => {
    try {
        const response = await commonRunQuery(312, selectedUser);
        if(response?.data?.header?.callStatus == "1") {
            // const responseData = setAsArray(response?.data?.body?.record);
            // console.log("response===========",responseData);
            const record = response?.data?.body?.record;
            const responseData = record == null || record === "" ? [] : setAsArray(record);
            setOFACHistory(responseData);
        }
    } catch(error) {
        console.log("getOFACHistoryData_error===========",error);
    } finally {
        setIsLoading(false);
    }
  }

  // console.log(smsData)

  //@Param date: format `YYYY-MM-DD HH:MM:SS`
  const formatDate = (date) => {
    const [day, time] = date.split(" ");
    return { day: day.slice(2, 10), time };
  };

  return (
    <Box className="table-sizing" sx={{ overflow: "auto" }}>
        <Typography sx={{}} className="mb-2">
            OFAC History
        </Typography> 
        {isLoading == true ? (
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    width: "100%",
                    overflow: "hidden",
                }}
            >
                <CircularProgress />
            </Box>
        ) : (
            <UserOFACTable 
                ofacData={oFACHistory}
                handleSelectedUser={null}
                targetID={null}
                systemRoles={[]}
                userStatus={null}
            />
        )}
    </Box>
  );
}

export default OFACHistory;
